import { Country } from "../Country";
import { Material } from "../Material";

export class MaterialLabelEntity{
    public id: string;
    public material: Material;
    public oem: Oem;
    public region: Country;
    public idSessionFront: string;
    public idSessionBack: string;
    public updateDate: Date;
    public updateUsername: string;
    public fileFrontExists: boolean;
    public fileBackExists: boolean;
    public previewFrontExists: boolean;
    public previewBackExists: boolean;
    public zoomFront: boolean;
    public zoomBack: boolean;
}

export class Oem{
    public id: string;
}